import { render } from "./NotificationForMeeting.vue?vue&type=template&id=4d658e75&scoped=true"
import script from "./NotificationForMeeting.vue?vue&type=script&lang=js"
export * from "./NotificationForMeeting.vue?vue&type=script&lang=js"

import "./NotificationForMeeting.vue?vue&type=style&index=0&id=4d658e75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d658e75"]])

export default __exports__